/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapDispatchToProps = exports.mapStateToProps = exports.name = exports.Modal = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var icon_close_png_1 = __importDefault(require("./assets/icon-close.png"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var ImageUtils_1 = __importDefault(require("./utils/ImageUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'Modal';
exports.name = name;

var Modal = function Modal(_ref) {
  var Frame = _ref.Frame,
      Image = _ref.Image,
      Text = _ref.Text,
      Button = _ref.Button,
      ConflictModal = _ref.ConflictModal,
      styles = _ref.styles,
      AnalyticsApi = _ref.AnalyticsApi;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.handleCloseClick = _this.handleCloseClick.bind(_assertThisInitialized(_this));
      _this.renderByType = _this.renderByType.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var onCancel = this.props.onCancel;

        if (onCancel) {
          onCancel();
        }
      }
    }, {
      key: "handleCloseClick",
      value: function handleCloseClick(e) {
        var closeModal = this.props.closeModal;
        closeModal();
      }
    }, {
      key: "renderByType",
      value: function renderByType(modalType) {
        var _a, _b;

        var _this$props = this.props,
            classes = _this$props.classes,
            closeModal = _this$props.closeModal,
            env = _this$props.env,
            modalData = _this$props.modalData,
            model = _this$props.model,
            select = _this$props.select;

        switch (modalType) {
          case 'conflict':
            {
              return react_1.default.createElement(ConflictModal, {
                modalData: modalData
              });
            }

          case 'info':
            {
              var property = modalData.property;
              var active = (_a = modalData.active) !== null && _a !== void 0 ? _a : property === null || property === void 0 ? void 0 : property.active;
              var featureImage = modalData.image || (property === null || property === void 0 ? void 0 : property.image);

              var _name = modalData.name || (property === null || property === void 0 ? void 0 : property.name);

              var price = modalData.price || (property === null || property === void 0 ? void 0 : property.price);
              var description = modalData.description || ((_b = modalData.property) === null || _b === void 0 ? void 0 : _b.description);

              var addToBuild = function addToBuild() {
                var attributeId = property.attributeId,
                    id = property.id;

                var selection = _defineProperty({}, attributeId, id);

                AnalyticsApi.selectedProperty(selection);
                select(attributeId, id);
                closeModal();
              };

              return react_1.default.createElement(Frame, {
                className: ['Modal__info-container', classes === null || classes === void 0 ? void 0 : classes.infoContainer],
                style: styles === null || styles === void 0 ? void 0 : styles.infoContainer
              }, featureImage && react_1.default.createElement(Frame, {
                className: ['Modal__feature-image-wrapper', classes === null || classes === void 0 ? void 0 : classes.featureImageWrapper],
                style: styles === null || styles === void 0 ? void 0 : styles.featureImageWrapper
              }, react_1.default.createElement(Image, {
                className: ['Modal__feature-image', classes === null || classes === void 0 ? void 0 : classes.featureImage],
                src: ImageUtils_1.default.getThumbnailUrl(env, model, featureImage),
                style: styles === null || styles === void 0 ? void 0 : styles.featureImage
              })), react_1.default.createElement(Frame, {
                className: ['Modal__content', classes === null || classes === void 0 ? void 0 : classes.content],
                style: styles === null || styles === void 0 ? void 0 : styles.content
              }, react_1.default.createElement(Text, {
                className: ['Modal__title', classes === null || classes === void 0 ? void 0 : classes.title, classes === null || classes === void 0 ? void 0 : classes.infoTitle],
                style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.title), styles === null || styles === void 0 ? void 0 : styles.infoTitle)
              }, _name), react_1.default.createElement(Text, {
                className: ['Modal__price', classes === null || classes === void 0 ? void 0 : classes.price],
                style: styles === null || styles === void 0 ? void 0 : styles.price
              }, price ? "$".concat(price.toLocaleString()) : ''), description && react_1.default.createElement(Text, {
                className: ['Modal__description', classes === null || classes === void 0 ? void 0 : classes.description],
                style: styles === null || styles === void 0 ? void 0 : styles.description
              }, description), active !== false && !property.included && react_1.default.createElement(Button, {
                className: ['Modal__button', classes === null || classes === void 0 ? void 0 : classes.addToBuild],
                onClick: addToBuild,
                style: styles === null || styles === void 0 ? void 0 : styles.addToBuild
              }, "Add To Build")));
            }

          case 'thumbnail-only':
            {
              var _property = modalData.property;

              var _featureImage = modalData.image || (_property === null || _property === void 0 ? void 0 : _property.image);

              return react_1.default.createElement(Frame, {
                className: ['Modal__info-container', classes === null || classes === void 0 ? void 0 : classes.infoContainer],
                style: styles === null || styles === void 0 ? void 0 : styles.infoContainer
              }, _featureImage && react_1.default.createElement(Frame, {
                className: ['Modal__feature-image-wrapper', classes === null || classes === void 0 ? void 0 : classes.featureImageWrapper],
                style: styles === null || styles === void 0 ? void 0 : styles.featureImageWrapper
              }, react_1.default.createElement(Image, {
                className: ['Modal__feature-image', classes === null || classes === void 0 ? void 0 : classes.featureImage, classes === null || classes === void 0 ? void 0 : classes.thumbnailOnly],
                src: ImageUtils_1.default.getThumbnailUrl(env, model, _featureImage),
                style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.featureImage), styles === null || styles === void 0 ? void 0 : styles.thumbnailOnly)
              })));
            }

          default:
            break;
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            after = _this$props2.after,
            before = _this$props2.before,
            children = _this$props2.children,
            classes = _this$props2.classes,
            modalType = _this$props2.modalType,
            type = _this$props2.type;
        return react_1.default.createElement(react_1.default.Fragment, null, modalType === type && react_1.default.createElement(Frame, {
          className: ['Modal__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Image, {
          className: ['Modal__close-button', classes === null || classes === void 0 ? void 0 : classes.close],
          onClick: this.handleCloseClick,
          src: icon_close_png_1.default,
          style: styles === null || styles === void 0 ? void 0 : styles.close
        }), react_1.default.createElement(Frame, {
          className: ['Modal__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, children ? children : this.renderByType(type)), after));
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Modal = Modal;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      app = state.app,
      session = state.session,
      ui = state.ui;
  var env = app.env;
  var modalData = ui.modalData,
      modalType = ui.modalType;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  return {
    env: env,
    modalData: modalData,
    modalType: modalType,
    model: model
  };
};

exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = {
  closeModal: brightsmith_redux_1.Actions.Ui.closeModal
};
exports.mapDispatchToProps = mapDispatchToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;

  return {
    addToBuild: Object.assign(Object.assign(Object.assign({
      backgroundColor: (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary,
      borderRadius: 4,
      borderWidth: 0,
      color: '#fff',
      cursor: 'pointer',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 25
    }, StyleUtils_1.default.padding('10px 25px')), {
      textTransform: 'uppercase'
    }), (_b = theme.Modal) === null || _b === void 0 ? void 0 : _b.addToBuild),
    container: Object.assign({
      background: '#fff',
      boxSizing: 'border-box',
      display: 'flex',
      margin: 'auto',
      maxWidth: 500,
      paddingBottom: 15,
      paddingLeft: 30,
      paddingRight: 30,
      paddingTop: 15,
      position: 'relative',
      width: '100%'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _c === void 0 ? void 0 : _c.container),
    close: Object.assign(Object.assign({
      color: (_d = theme.colors) === null || _d === void 0 ? void 0 : _d.secondary,
      cursor: 'pointer',
      height: 40,
      position: 'absolute',
      right: 15,
      top: 15,
      width: 40
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _e === void 0 ? void 0 : _e.close), _defineProperty({}, "@media (max-width: ".concat((_f = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _f === void 0 ? void 0 : _f.mobile, "px)"), {
      height: 24,
      width: 24
    })),
    content: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_g = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _g === void 0 ? void 0 : _g.content),
    description: Object.assign({
      fontSize: 15,
      lineHeight: '17px',
      marginTop: 20
    }, (_h = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _h === void 0 ? void 0 : _h.description),
    featureImage: Object.assign({
      maxHeight: 250
    }, (_j = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _j === void 0 ? void 0 : _j.featureImage),
    featureImageWrapper: Object.assign({
      alignItems: 'center',
      display: 'flex',
      justifyItems: 'center'
    }, (_k = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _k === void 0 ? void 0 : _k.featureImageWrapper),
    infoContainer: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_l = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _l === void 0 ? void 0 : _l.infoContainer),
    infoTitle: Object.assign({}, (_m = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _m === void 0 ? void 0 : _m.infoTitle),
    inner: Object.assign({
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }, (_o = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _o === void 0 ? void 0 : _o.inner),
    price: Object.assign({
      paddingTop: 15
    }, (_p = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _p === void 0 ? void 0 : _p.price),
    thumbnailOnly: Object.assign({
      margin: '0 auto',
      maxWidth: '90%'
    }, (_q = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _q === void 0 ? void 0 : _q.thumbnailOnly),
    title: Object.assign({
      fontSize: 20,
      fontWeight: '100'
    }, (_r = theme === null || theme === void 0 ? void 0 : theme.Modal) === null || _r === void 0 ? void 0 : _r.title)
  };
};

exports.style = style;